import { ICON__loader } from '@/assets/icons_lucide';
import { use_slice_network, use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { string_to_span } from '@/utils/utils_html';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__tooltip } from '../../../components/ui/UI_PRIMITIVE__tooltip';

export function HARDWARE_STATS__waiting_response() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { responses_ids__wait_to } = use_slice_network(['avg_server_latency', 'responses_ids__wait_to']);
  const { global_need_show_first_animation } = use_slice_ui(['global_need_show_first_animation']);

  const tooltip = useMemo(() => get_tootlip(), [responses_ids__wait_to]);
  const class_name_icon = useMemo(() => get_class_name_icon(), [responses_ids__wait_to]);

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  function get_tootlip() {
    return `Responses waiting: ${responses_ids__wait_to.size}`;
  }

  function get_class_name_icon() {
    let { size } = responses_ids__wait_to;

    if (size === 0) {
      return ` opacity-0 pointer-events-none !text-green-700`;
    } else if (size <= 5) {
      return ` opacity-100 !text-green-700`;
    } else {
      return ` opacity-100 !text-orange-400`;
    }
  }

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={string_to_span(tooltip)} side="right" delay_duration={0}>
      <div
        className={`flex-1 h-full flex flex-center 
          ${global_need_show_first_animation ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
      >
        <ICON__loader className={`transition-opacity duration-500  size-2.5 animate-spin ${class_name_icon}`} />
      </div>
    </UI_PRIMITIVE__tooltip>
  );
}
